module.exports = {"410311002":"开元路街道","410311003":"龙门石窟街道","410311004":"关林街道","410311005":"太康东路街道","410311006":"古城街道","410311007":"科技园街道","410311008":"翠云路街道","410311009":"龙门街道","410311010":"学府街道","410311011":"定鼎门街道","410311102":"安乐镇","410311103":"白马寺镇","410311107":"李楼镇","410311194":"寇店镇","410311195":"诸葛镇","410311196":"李村镇","410311197":"庞村镇","410311199":"佃庄镇"}


//////////////////
// WEBPACK FOOTER
// ./src/town/410311.json
// module id = 1664
// module chunks = 0